//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function loadReportsService(idProduct, startDateFilter, endDateFilter) {
    try {

        if (!idProduct || !startDateFilter || !endDateFilter) {
            console.log("Entrou no null")
            return null;
        }

        const response = await api.get(`/relatorios/orderbumps-por-grupo`, {
            params: {
                id_grupo: idProduct,
                data_inicio: startDateFilter,
                data_fim: endDateFilter
            }
        })
        return response;
    } catch (error) {
        toast.error("Erro ao carregar relatórios!");
        return null;
    }
}